import { makeStyles } from '@material-ui/core/styles'

export const studentServiceCenterStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  content: {
    padding: 0,
  },
  modalTabs: {
    width: 335,
    height: 35,
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  oneStopHeader: {
    color: theme.palette.base.red,
    margin: '6px 0 !important',
  },
  oneStopHeaderSpan: {
    color: theme.palette.base.gray,
  },
  searchBar: {
    paddingLeft: 10,
    paddingRight: 10,
    marginBottom: 5,
  },
  accordion: {
    padding: '0px 0px',
  },
  divider: {
    backgroundColor: theme.palette.base.red,
    height: '3px',
  },
  linkText: {
    '&:hover': {
      color: theme.palette.base.red,
    },
  },
  eventCard: {
    width: '95%',
    padding: 10,
    margin: '10px auto',
  },
  eventGridItem: {
    marginTop: 20,
    marginBottom: 20,
  },
  rbhsStudentNewCases: {
    marginTop: 0,
    marginBottom: 20,
  },
  descriptionGridItem: {
    padding: '20px 5px',
  },
  caseButtonGridItem: {
    display: 'flex',
    paddingTop: 20,
    marginBottom: 20,
  },
  newCaseButton: {
    borderRadius: 25,
    backgroundColor: theme.palette.base.red,
    color: theme.palette.base.white,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  tabPanel: {
    width: '100%',
    height: 303,
    maxHeight: 303,
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 373px)',
    },
  },
  tabBackground: {
    width: '100%',
    height: 35,
    backgroundColor: theme.palette.backgroundColor.secondary,
  },
  tabTextLabel: {
    fontSize: 14,
  },
  newCasesList: {
    height: '100%',
    overflow: 'clip',
    overflowY: 'auto',
    padding: theme.spacing(1),
  },
  casesList: {
    height: 'calc(100% - 34px)',
    overflow: 'clip',
    overflowY: 'auto',
    padding: theme.spacing(1),
  },
  casesNewCard: {
    height: 'auto',
    padding: theme.spacing(1, 2),
    margin: theme.spacing(0.5, 0),
    width: '100%',
  },
  casesNewCasesTextColor: {
    color: theme.palette.base.green,
  },
  casesClosedCasesTextColor: {
    color: theme.palette.base.red,
  },
  casesClosedCard: {
    width: '95%',
    padding: 10,
    margin: '10px auto',
  },
  bottomContainer: {
    width: '100%',
  },
  gridContainer: {
    height: '100%',
    display: 'flex',
  },
  oneStopSubheader: {
    color: theme.palette.primary,
    fontSize: 9,
    textAlign: 'center',
  },
  studentServiceCenterFooter: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontWeight: 600,
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'none',
      color: theme.palette.base.blue,
    },
  },
  circleIcon: {
    fontSize: 70,
    color: theme.palette.base.green,
  },
}))

export default studentServiceCenterStyles
